import { connect } from "react-redux";
import { getById } from "../../store/global/actions";

const Footer = () => {
  const companyDetail = JSON.parse(localStorage.getItem("companyDetails"));

  return (
    <footer className="bottomBar small-text pt-1 text-dark d-flex  justify-content-between px-3">
      <div></div>
      <div className="footer-name  text-truncate">
        Company Name :&nbsp;
        <span className="text-primary small-text">
          {companyDetail?.name || ""}
        </span>
      </div>
      <div className=" text-truncate">
        Powered By:
        <span className="text-primary"> Nead IT Solution Pvt. Ltd.</span>
      </div>
    </footer>
  );
};

export default connect((state) => ({ companyId: state.global.companyId }), {
  getById,
})(Footer);
